import { useMemo } from "react";
import moment from "moment";

export function useMoment(timestamp) {
    return useMemo(() => moment.unix(timestamp), [timestamp]);
}
